import React, { useState } from 'react'
import client from '../../../api/client'
import qs from 'query-string'

const UnlockAccount = () => {
  const [id, setId] = useState('')
  const [certSeq, setCertSeq] = useState('')
  const [certNo, setCertNo] = useState('')
  const [isDisableCertBtn, setIsDisableCertBtn] = useState(true)
  const [isDisableUnlockBtn, setIsDisableUnlockBtn] = useState(true)

  const onChangeId = (e) => {
    setId(e.target.value)
    setIsDisableCertBtn(e.target.value.length === 0)
  }

  const onChangeCertNo = (e) => {
    setCertNo(e.target.value)
    setIsDisableUnlockBtn(e.target.value.length === 0 || id.length === 0)
  }

  const onRequestCert = () => {
    const data = qs.stringify({ simpleId: id })

    client.post('/api/v2/user/unlock/request', data)
      .then(response => {
        if (response.status === 200 || response.status === "200") {
          // 보통 status가 0이면 성공으로 처리 (API 응답 형식에 따라 다를 수 있음)
          if (response.data.status === 0 || response.data.status === "0") {
            const receivedCertSeq = (response.data.data && response.data.data.certSeq) || response.data.certSeq;
            setCertSeq(receivedCertSeq || '');
            alert("인증요청이 발송되었습니다. 휴대폰 문자를 확인해주세요.");
          } else {
            alert(response.data.message || "인증요청에 실패했습니다.");
          }
        }
      })
      .catch(error => {
        console.error(error);
        alert("서버와 통신 중 오류가 발생했습니다.");
      });
  }

  const onUnlockAccount = () => {
    if (!certSeq) {
      alert("먼저 인증요청을 진행해주세요.");
      return;
    }

    const data = qs.stringify({
      simpleId: id,
      certSeq: certSeq,
      certNo: certNo
    })

    client.post('/api/v2/user/unlock/verify', data)
      .then(response => {
        if (response.status === 200 || response.status === "200") {
          if (response.data.status === 0 || response.data.status === "0") {
            alert("계정잠금 해제가 완료되었습니다. 다시 로그인해주세요.");
            // 로그인 페이지로 이동 (옵션)
            window.location.href = '/login';
          } else {
            alert(response.data.message || "인증확인에 실패했습니다.");
          }
        }
      })
      .catch(error => {
        console.error(error);
        alert("서버와 통신 중 오류가 발생했습니다.");
      });
  }

  return (
    <div className="content_box find_by find_id">
      {/*상단 설명*/}
      <div className="group group1">
        <div className="content_desc">
          <p>잠긴 계정을 휴대폰 문자인증을 통해<br />잠금해제할 수 있습니다.<br />아이디를 입력해주세요.</p>
        </div>
      </div>

      {/*입력 양식*/}
      <div className="group2 id_mobile_form">
        <div className="group group2_1">
          <form action="" method="" name="unlock_account_form">
            <div className="input_field">
              {/*아이디*/}
              <div className="input_row id clearfix">
                <div className="input_tit">
                  <label htmlFor="user_id">아이디</label>
                </div>
                <div className="input_content clearfix">
                  <input type="text" id="user_id" name="user_id" className="cell float_l" placeholder="아이디" onChange={onChangeId} value={id} />
                  <button type="button" className={`float_l ${isDisableCertBtn ? '' : 'active'}`} disabled={isDisableCertBtn} onClick={onRequestCert}>인증요청</button>
                </div>
              </div>

              {/*인증번호 확인*/}
              <div className="input_row num_confirm clearfix">
                <div className="input_tit">
                  <label htmlFor="num_confirm">인증번호</label>
                </div>
                <div className="input_content clearfix">
                  <input type="text" id="num_confirm" name="num_confirm" className="cell float_l" placeholder="인증번호 6자 입력" maxLength="6" onChange={onChangeCertNo} value={certNo} />
                  <button type="button" className={`float_l ${isDisableUnlockBtn ? '' : 'active'}`} disabled={isDisableUnlockBtn} onClick={onUnlockAccount}>인증확인</button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/*하단 설명*/}
        <div className="group group2_2 id_mobile_desc">
          <div className="txt_wrap" style={{ textAlign: 'center' }}>
            <strong>[계정잠금 해제 안내]</strong>
            <p>인증확인이 완료되면 계정잠금이 해제됩니다.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UnlockAccount
